import { ModuleTree } from "vuex";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Vuex app module
 */
export const AppModule: ModuleTree<unknown> = {
  app: {
    namespaced: true,
    state: {
      title: "",
      titlePrefix: ""
    },
    mutations: {
      /**
       * Initializes app state
       * @param state Vuex state
       */
      init(state) {
        state.title = document.title;
      },

      /**
       * Updates app title prefix
       * @param state Vuex state
       * @param newPrefix New app title prefix
       */
      setTitlePrefix(state, newPrefix: string) {
        state.titlePrefix = newPrefix;
        document.title = `${state.titlePrefix} • ${state.title}`;
      }
    }
  }
};
